import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20amber%20and%20cream%20gradient%20abstract%20background%2C%20soft%20flowing%20geometric%20shapes%2C%20minimalist%20modern%20design%2C%20smooth%20curves%2C%20gentle%20light%20beams%2C%20warm%20atmospheric%20tones%2C%20elegant%20digital%20platform%20backdrop%2C%20clean%20and%20sophisticated%20composition&width=1800&height=900&seq=hero-bg-cheng91&orientation=landscape"
          alt="成91官方平台"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/15 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-28">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm mb-8">
            <i className="ri-verified-badge-line"></i>
            <span>成91官方认证平台 · 安全可信赖</span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-6 leading-tight">
            成91官方入口
            <span className="block text-primary-300 mt-2">最新地址与使用指南</span>
          </h1>

          <p className="text-lg md:text-xl text-background-200/90 max-w-2xl mx-auto mb-10 leading-relaxed">
            成91是备受用户关注的热门平台，为您提供官方入口、最新地址、使用教程及常见问题解答，帮助您快速找到成91并顺畅使用。
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/shiyong-jiaocheng"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 dark:text-foreground-950 rounded-lg text-base font-medium hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-open-line mr-2"></i>
              查看使用教程
            </Link>
            <Link
              to="/category/changjian-wenti"
              className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-lg text-base font-medium hover:bg-background-50/25 transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-question-answer-line mr-2"></i>
              常见问题解答
            </Link>
          </div>

          <div className="mt-14 flex flex-wrap items-center justify-center gap-8 md:gap-12">
            {[
              { value: '500万+', label: '注册用户' },
              { value: '98.7%', label: '用户满意度' },
              { value: '15+', label: '行业奖项' },
              { value: '7×24', label: '客服支持' },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">{stat.value}</div>
                <div className="text-sm text-background-300 mt-1">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden md:block">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}